import { initializeApp } from 'firebase/app';
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getAuth, FacebookAuthProvider } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getMessaging } from 'firebase/messaging';
import { getAnalytics, setAnalyticsCollectionEnabled } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';
import { env } from './env';

const firebaseConfig = {
  apiKey: env.firebase.apiKey,
  authDomain: env.firebase.authDomain,
  projectId: env.firebase.projectId,
  storageBucket: env.firebase.storageBucket,
  messagingSenderId: env.firebase.messagingSenderId,
  appId: env.firebase.appId,
  measurementId: env.firebase.measurementId
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firestore with multi-tab persistence
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

export const auth = getAuth(app);
export const storage = getStorage(app);
export const messaging = getMessaging(app);
export const functions = getFunctions(app, 'europe-west1');

// Configure Facebook Auth Provider
export const facebookProvider = new FacebookAuthProvider();
facebookProvider.addScope('email');
facebookProvider.addScope('public_profile');
facebookProvider.setCustomParameters({
  'display': 'popup',
  'auth_type': 'rerequest',
  'locale': 'fr_FR'
});

// Initialize Analytics only in browser environment
let analytics = null;
if (typeof window !== 'undefined' && env.MODE !== 'staging') {
  try {
    analytics = getAnalytics(app);
    setAnalyticsCollectionEnabled(analytics, true);
  } catch (error) {
    console.warn('Analytics initialization failed:', error);
  }
}
export { analytics };

// Enable Firestore offline persistence if needed
// enableIndexedDbPersistence(db).catch((err) => {
//   if (err.code === 'failed-precondition') {
//     // // // // // // // // console.log('Multiple tabs open, persistence can only be enabled in one tab at a a time.');
//   } else if (err.code === 'unimplemented') {
//     // // // // // // // // console.log('The current browser doesn\'t support all of the features required to enable persistence');
//   }
// });

// Export app instance if needed elsewhere
export default app; 